import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { brandInfo } from "../../_services/index";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../Firebase/firebase'
//import connectionSvg from "../../Data/undraw_connection.svg";
import "./RegisterationFinal.css";
import BackgroundDecorations from "../Common/BackgroundDecorations";

const RegisterationFinal = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Get current language direction
  const isRTL = i18n.language === 'he';

  const validateForm = (formData) => {
    const newErrors = {};

    if (!formData.get("email")) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.get("email"))) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.get("password")) {
      newErrors.password = "Password is required";
    } else if (formData.get("password").length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (!formData.get("confirmPassword")) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (formData.get("password") !== formData.get("confirmPassword")) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (!formData.get("accountName")) {
      newErrors.accountName = "Account name is required";
    }

    if (!phoneNumber) {
      newErrors.phone = "Phone number is required";
    }

    if (!formData.get("terms")) {
      newErrors.terms = "You must accept the terms and conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});

    try {
      const form = formRef.current;
      if (!form) {
        toast.error("Form reference is missing!");
        return;
      }

      const formData = new FormData(form);

      if (!validateForm(formData)) {
        setIsSubmitting(false);
        return;
      }

      const email = formData.get("email");
      const password = formData.get("password");
      const accountName = formData.get("accountName");
      const address = formData.get("address")

      // First create Firebase user
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("Firebase user created:", userCredential.user.uid);
      } catch (firebaseError) {
        console.error("Firebase error:", firebaseError);
        if (firebaseError.code === 'auth/email-already-in-use') {
          toast.error("Email already in use. Please use a different email or sign in.");
        } else {
          toast.error("Failed to create account. Please try again.");
        }
        setIsSubmitting(false);
        return;
      }

      // Then create business
      const data = {
        email,
        address,
        password,
        name: accountName,
        information: {
          name: accountName,
          address: address,
          phone: phoneNumber,
          openingHours1: "",
          openingHours2: "",
          contactName: "",
          description: accountName,
          picture_url: "",
          brandInfoSmallLogo: "",
        },
      };

      const response = await brandInfo(data);
      const business = JSON.parse(response);

      // Store user data in localStorage
      localStorage.setItem('user', JSON.stringify({
        email: email,
        business_id: business.business_id,
        name: accountName,
        address : address
      }));

      toast.success("Account created successfully");
      navigate('/Login', { state: { email: email } });
    } catch (error) {
      console.error("Registration error:", error);
      toast.error("Failed to create account. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <BackgroundDecorations />
      <div className="registration-container" dir={isRTL ? 'rtl' : 'ltr'}>
        <ToastContainer />

        {/* Add connection SVG with proper coloring */}
        <div style={{ isolation: 'isolate' }}>
          {/*<img*/}
          {/*  //src={connectionSvg}*/}
          {/*    src={}*/}
          {/*  className="registration-connection-svg"*/}
          {/*  alt="Connection illustration"*/}
          {/*/>*/}
        </div>

        {/* Header */}
        <div className="header">
          <img
            className="logo"
            src="./images/Group 7571.png"
            alt="Logo"
          />
        </div>

        {/* Form Section */}
        <div className="form-container">
          {/* Add accent line from design system */}
          <div className="form-card-accent"></div>

          <div className="form-header">
            <h1>{t("createAccount")}</h1>
          </div>

          <form ref={formRef} onSubmit={handleSubmit} className="form">
            <div className="form-content">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">
                    {t("accountName")} <span className="required">*</span>
                    <div data-title="Account Name" className="helpDiv">
                      <img
                        className="help-icon"
                        src="./images/yellow-mark.png"
                        alt="Help"
                      />
                    </div>
                  </label>
                  <input
                    type="text"
                    name="accountName"
                    placeholder={t("accountNamePlaceholder")}
                    className="form-input"
                    dir={isRTL ? 'rtl' : 'ltr'}
                  />
                  {errors.accountName && <span className="error-message">{errors.accountName}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">
                    {t("phoneNumber")} <span className="required">*</span>
                    <div data-title="Enter Phone" className="helpDiv">
                      <img
                        className="help-icon"
                        src="./images/yellow-mark.png"
                        alt="Help"
                      />
                    </div>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder={t("phoneNumberPlaceholder")}
                    className="form-input"
                    dir={isRTL ? 'rtl' : 'ltr'}
                  />
                  {errors.phone && <span className="error-message">{errors.phone}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    {t("address")}
                    <div data-title="Adress" className="helpDiv">
                      <img
                          className="help-icon"
                          src="./images/yellow-mark.png"
                          alt="Help"
                      />
                    </div>
                  </label>
                  <input
                      type="address"
                      name="address"
                      placeholder={t("addressPlaceholder")}
                      className="form-input"
                      dir={isRTL ? 'rtl' : 'ltr'}
                  />
                  {errors.address && <span className="error-message">{errors.address}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    {t("email")} <span className="required">*</span>
                    <div data-title="Email" className="helpDiv">
                      <img
                        className="help-icon"
                        src="./images/yellow-mark.png"
                        alt="Help"
                      />
                    </div>
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder={t("emailPlaceholder")}
                    className="form-input"
                    dir={isRTL ? 'rtl' : 'ltr'}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    {t("password")} <span className="required">*</span>
                    <div data-title="Password" className="helpDiv">
                      <img
                        className="help-icon"
                        src="./images/yellow-mark.png"
                        alt="Help"
                      />
                    </div>
                  </label>
                  <input
                    type="password"
                    name="password"
                    placeholder={t("passwordPlaceholder")}
                    className="form-input"
                    dir={isRTL ? 'rtl' : 'ltr'}
                  />
                  {errors.password && <span className="error-message">{errors.password}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    {t("confirmPassword")} <span className="required">*</span>
                    <div data-title="Confirm Password" className="helpDiv">
                      <img
                        className="help-icon"
                        src="./images/yellow-mark.png"
                        alt="Help"
                      />
                    </div>
                  </label>
                  <input
                    type="password"
                    name="confirmPassword"
                    placeholder={t("confirmPasswordPlaceholder")}
                    className="form-input"
                    dir={isRTL ? 'rtl' : 'ltr'}
                  />
                  {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
                </div>
              </div>
            </div>

            <div className="terms-group">
              <input
                type="checkbox"
                name="terms"
                className="terms-checkbox"
              />
              <span className="terms-text">
                {t("iAccept")}
                <a href="#" className="terms-link">{t("termsOfService")}</a>
                <span> {t("&")} </span>
                <a href="#" className="terms-link">{t("privacyPolicy")}</a>
              </span>
            </div>
            {errors.terms && <span className="error-message">{errors.terms}</span>}

            <button
              type="submit"
              disabled={isSubmitting}
              className="submit-button"
            >
              {isSubmitting ? t("creatingAccount") : t("createAccount")}
            </button>

            <div className="login-link">
              {t("alreadyHaveAccount")}
              <Link to="/Login"> {t("signIn")}</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RegisterationFinal;